"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBefore = exports.addSeconds = exports.formatForDateLocal = exports.formatDate = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const formatDate = (date, format = 'DD MMM YY hh:mm') => {
    try {
        return (0, dayjs_1.default)(date).format(format);
    }
    catch (_a) {
        return '';
    }
};
exports.formatDate = formatDate;
const formatForDateLocal = (value) => (0, exports.formatDate)(value, 'YYYY-MM-DDTHH:mm');
exports.formatForDateLocal = formatForDateLocal;
const addSeconds = (date, seconds) => {
    try {
        return (0, dayjs_1.default)(date).add(seconds, 'seconds').toDate();
    }
    catch (_a) {
        return date;
    }
};
exports.addSeconds = addSeconds;
const isBefore = (date, secondDate) => {
    try {
        return (0, dayjs_1.default)(date).isBefore(secondDate);
    }
    catch (_a) {
        return false;
    }
};
exports.isBefore = isBefore;
